import React from "react";
import "./Pricing2.css";

const Pricing = () => {
  return (
    <section className="pricing-section m11 Onlybottom-border">
      <div className="pricing-left">
        <div className="pricing-content Home-all">
          <h3 className="black">Pricing</h3>
          <h1 className="pt">
            Affordable <br />
            Business Valuation <br />
            Plans for Every Stage
          </h1>
          {/* <p>Startups to enterprises: Scale with flexible pricing.</p> */}
          <p>
            Whether you're a startup or an established business, we offer plans
            designed to scale with your growth.
          </p>
          <h6 className="special-offer">Do you need a special offer?</h6>
          <a href="#contact" className="special-offer-a">
            Write to us
          </a>
        </div>
      </div>

      <div className="pricing-right">
        <div className="pricing-card">
          <div className="clybourne-card">
            <h4 className="card-title">Clybourne’s Online Valuation Tool</h4>
            <hr />
            <p className="card-price">From $109</p>
            <p className="card-price">(Save 90%)</p>
            <button className="get-started-button">Get Started</button>
          </div>
        </div>

        <div className="traditional-card">
          <h4 className="card-title">Traditional Valuation Cost</h4>
          <hr />
          <p className="card-price">$10,000+</p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
